var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab-assignments-widget"},[_c('div',[_c('allLabAssignmentsOverview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }